// Primary API: restcountries.com
export const getCountriesApi = async (search = '') => {
  try {
    const url = `https://api.restcountries.com/countries/v5?q=${search || "a"}&limit=10`;
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_RESTCOUNTRIES_KEY}`,
      },
    });
    if (!response.ok) throw new Error('Primary API failed');
    
    const data = await response.json();
    return data.map(country => ({
      name: country.name.common,
      currency: Object.keys(country.currencies || {})[0] || 'USD',
      isoCode: country.cca2,
      countryCode: country.idd.root
        ? country.idd.root + (country.idd.suffixes?.length 
            ? (country.name.common === "United States" ? "" : country.idd.suffixes[0])
            : "")
        : ""
    }));
  } catch (primaryError) {
    console.warn('Primary API failed, trying fallback...', primaryError);
    
    // Fallback API: countriesnow.space
    try {
      const fallbackResponse = await fetch('https://countriesnow.space/api/v0.1/countries/currency');
      if (!fallbackResponse.ok) throw new Error('Fallback API failed');
      
      const fallbackData = await fallbackResponse.json();
      if (fallbackData.error || !fallbackData.data) throw new Error('Invalid fallback response');
      
      let countries = fallbackData.data;
      
      // Filter by search if provided
      if (search) {
        countries = countries.filter(country => 
          country.name.toLowerCase().includes(search.toLowerCase())
        );
      }
      
      return countries.map(country => ({
        name: country.name,
        currency: country.currency || 'USD',
        isoCode: country.iso2 || '',
        countryCode: ''
      }));
    } catch (fallbackError) {
      console.error('Both APIs failed:', fallbackError);
      return [];
    }
  }
};

export const getAllCountriesApi = async () => {
  try {
     const response = await fetch(
      "https://api.restcountries.com/countries/v5",
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_RESTCOUNTRIES_KEY}`,
        },
      },
    );
    if (!response.ok) throw new Error('Primary API failed');
    
    const data = await response.json();
    return data.map(country => ({
      name: country.name.common,
      currency: Object.keys(country.currencies || {})[0] || 'USD',
      isoCode: country.cca2,
      countryCode: country.idd.root
        ? country.idd.root + (country.idd.suffixes?.length 
            ? (country.name.common === "United States" ? "" : country.idd.suffixes[0])
            : "")
        : ""
    }));
  } catch (primaryError) {
    console.warn('Primary API failed, trying fallback...', primaryError);
    
    // Fallback API
    try {
      const fallbackResponse = await fetch('https://countriesnow.space/api/v0.1/countries/currency');
      if (!fallbackResponse.ok) throw new Error('Fallback API failed');
      
      const fallbackData = await fallbackResponse.json();
      if (fallbackData.error || !fallbackData.data) throw new Error('Invalid fallback response');
      
      return fallbackData.data.map(country => ({
        name: country.name,
        currency: country.currency || 'USD',
        isoCode: country.iso2 || '',
        countryCode: ''
      }));
    } catch (fallbackError) {
      console.error('Both APIs failed:', fallbackError);
      return [];
    }
  }
};